import { render } from "./UiPhotoViewer.vue?vue&type=template&id=1f7bc9fa&scoped=true&lang=pug"
import script from "./UiPhotoViewer.vue?vue&type=script&lang=js"
export * from "./UiPhotoViewer.vue?vue&type=script&lang=js"

import "./UiPhotoViewer.vue?vue&type=style&index=0&id=1f7bc9fa&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7bc9fa"]])

export default __exports__